import { render, staticRenderFns } from "./Subcollections.vue?vue&type=template&id=140a3466"
import script from "./Subcollections.vue?vue&type=script&lang=js"
export * from "./Subcollections.vue?vue&type=script&lang=js"
import style0 from "./Subcollections.vue?vue&type=style&index=0&id=140a3466&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports